<template>
  <div class="cm-discuss-item-videos">
    <video v-for="(image, index) in util.string2Array(videos)" :key="index" controls>
      <source :src="util.getImageUrl(image)" type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  name: "CommodityMarketingDiscussItemVideos",
  props: {
    videos: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="less" scoped>
.cm-discuss-item-videos {
  width: 100%;
  video {
    width: 245px;
    // height: 300px;
    border-radius: 5px;

    margin-right: 10px;
    margin-bottom: 10px;
  }
}
</style>
